"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigStruct = void 0;
const superstruct_1 = require("superstruct");
const Common_1 = require("../Common");
exports.ConfigStruct = (0, superstruct_1.partial)({
    debug: (0, superstruct_1.boolean)(),
    env: (0, superstruct_1.enums)(Object.keys(Common_1.SERVERS)),
    facetBasedFiltering: (0, superstruct_1.boolean)(),
    hostProductData: (0, superstruct_1.boolean)(),
    sendEvent: (0, superstruct_1.boolean)(),
    sessionDuration: (0, superstruct_1.object)({ hour: (0, superstruct_1.number)() }),
    sessionId: (0, superstruct_1.nullable)((0, superstruct_1.string)()),
    captureDocumentClickEvents: (0, superstruct_1.boolean)(),
    captureDocumentScrollEvents: (0, superstruct_1.boolean)(),
    documentScrollSessionDuration: (0, superstruct_1.number)(),
    disableAutoPageCapture: (0, superstruct_1.boolean)(),
});
